export const DEPARTURE_CITY_TEXTS = {
  fieldLabelFixed: 'Откуда',
  nothingFound: 'Ничего не найдено',
  errorEmpty: 'Выберите город вылета',
} as const;
